module.exports = __webpack_public_path__ + "static/media/34DSS7.fc33b7d0.jpg";